// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, enumOf, maybe } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

const campaignOrWorkflowValidator = objectOf({
  id: string,
  name: string,
});

export const isOfferfitAppGroupIdUseCasesUseCaseIdResult = objectOf({
  id: string,
  client: string,
  pipeline: string,
  usecase: string,
  usecase_display_name: string,
  // Second arg allows explicit JSON null, so an unresolved DSA tier
  // degrades gracefully instead of failing response validation.
  tier: maybe(string, true),
  // Keep in sync with the backend status union (OfferfitController#derive_agent_status).
  status: maybe(enumOf("live", "stopped", "draft"), true),
  campaigns: arrayOf(campaignOrWorkflowValidator),
  workflows: arrayOf(campaignOrWorkflowValidator),
});
